import React from 'react';
import PropTypes from 'prop-types';
import styles from '../HistoricalDashboardPage/HistoricalDashboardPage.module.scss';
import { HistoricDataGrid } from '../../components/HistoricDataGrid';
import { TDDS_TRADE_RATIO_SUMMARY, TDDS_SHARE_RATIO_SUMMARY, TDDS_NOTIONAL_RATIO_SUMMARY
} from '../../util/dashBoardPageConstants';
import getConfig from '../../config';
const { DASHBOARD_CONFIG } = getConfig();

const TDDS_TRADE_RATIO_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(TDDS_TRADE_RATIO_SUMMARY);
const TDDS_SHARE_RATIO_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(TDDS_SHARE_RATIO_SUMMARY);
const TDDS_NOTIONAL_RATIO_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(TDDS_NOTIONAL_RATIO_SUMMARY);

class HistoricalDashboardTddsGrids extends React.PureComponent {
  render () {
    const historicDateFormat = this.props.historicDateFormat;
    return (
      <div className={styles.tddsTables} >
        <HistoricDataGrid
          key={TDDS_TRADE_RATIO_SUMMARY_CONFIG.identifier}
          identifier={TDDS_TRADE_RATIO_SUMMARY_CONFIG.identifier}
          header={TDDS_TRADE_RATIO_SUMMARY_CONFIG.header}
          api={TDDS_TRADE_RATIO_SUMMARY_CONFIG.historicApi}
          downloadApi={TDDS_TRADE_RATIO_SUMMARY_CONFIG.downloadApi}
          historicDate={historicDateFormat}
          lastUpdatedField={TDDS_TRADE_RATIO_SUMMARY_CONFIG.lastUpdatedField}
          totalField={TDDS_TRADE_RATIO_SUMMARY_CONFIG.totalField}
          columns={TDDS_TRADE_RATIO_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={TDDS_TRADE_RATIO_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataCustomColumns={TDDS_TRADE_RATIO_SUMMARY_CONFIG.summaryGroupDataCustomColumns}
          maxRows={20}
        />

        <HistoricDataGrid
          key={TDDS_SHARE_RATIO_SUMMARY_CONFIG.identifier}
          identifier={TDDS_SHARE_RATIO_SUMMARY_CONFIG.identifier}
          header={TDDS_SHARE_RATIO_SUMMARY_CONFIG.header}
          api={TDDS_SHARE_RATIO_SUMMARY_CONFIG.historicApi}
          downloadApi={TDDS_SHARE_RATIO_SUMMARY_CONFIG.downloadApi}
          historicDate={historicDateFormat}
          lastUpdatedField={TDDS_SHARE_RATIO_SUMMARY_CONFIG.lastUpdatedField}
          totalField={TDDS_SHARE_RATIO_SUMMARY_CONFIG.totalField}
          columns={TDDS_SHARE_RATIO_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={TDDS_SHARE_RATIO_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataCustomColumns={TDDS_SHARE_RATIO_SUMMARY_CONFIG.summaryGroupDataCustomColumns}
          maxRows={20}
        />

        <HistoricDataGrid
          key={TDDS_NOTIONAL_RATIO_SUMMARY_CONFIG.identifier}
          identifier={TDDS_NOTIONAL_RATIO_SUMMARY_CONFIG.identifier}
          header={TDDS_NOTIONAL_RATIO_SUMMARY_CONFIG.header}
          api={TDDS_NOTIONAL_RATIO_SUMMARY_CONFIG.historicApi}
          downloadApi={TDDS_NOTIONAL_RATIO_SUMMARY_CONFIG.downloadApi}
          historicDate={historicDateFormat}
          lastUpdatedField={TDDS_NOTIONAL_RATIO_SUMMARY_CONFIG.lastUpdatedField}
          totalField={TDDS_NOTIONAL_RATIO_SUMMARY_CONFIG.totalField}
          columns={TDDS_NOTIONAL_RATIO_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={TDDS_NOTIONAL_RATIO_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataCustomColumns={TDDS_NOTIONAL_RATIO_SUMMARY_CONFIG.summaryGroupDataCustomColumns}
          maxRows={20}
        />
      </div>
    );
  }
}

export default HistoricalDashboardTddsGrids;
export const MemoizedHistoricalDashboardTddsGrids = React.memo(HistoricalDashboardTddsGrids);

HistoricalDashboardTddsGrids.propTypes = {
  historicDateFormat: PropTypes.string
};
